<template>
	<div>
	<el-dialog
		title="二维码绑定"
		:visible.sync="isErwm" :close-on-click-modal="false"
		center :before-close="closeErwm"
		width="500px">
		<div class="erwema">
			<!-- <div class="erm_biao">二维码绑定</div> -->
			<div class="erm_img">
				<img :src="ewm" alt="">
			</div>
			<p>扫二维码绑定微信号</p>
		</div>
	</el-dialog>
		<div class="personal_box"  v-loading="isTosub">
			<div class="per_zi clearfloat">
				<div class="per_left">当前头像:</div>
				<div class="per_right" @click="xin.goUrl('/personalCenter/head')">
					<img :src="ruleForm.avatar" />
				</div>
			</div>
			<div class="per_zi clearfloat">
				<div class="per_left">微信账号:</div>
				<div class="per_right">
					<template v-if="user.open_id" >已绑定</template>
					<button v-else @click="erwm(user.key)" class="laing_btn">绑定</button>
				</div>
			</div>
			<el-form label-position="right" label-width="180px" :model="ruleForm" :rules="rules" ref="ruleForm">
				<el-form-item label="用户名" prop="nickname">
					<el-input v-model="ruleForm.nickname"></el-input>
				</el-form-item>
				<el-form-item label="邮箱" prop="email">
					<el-input v-model="ruleForm.email"></el-input>
				</el-form-item>
				<el-form-item label="手机" prop="phone">
					<el-input v-model="ruleForm.phone"></el-input>
				</el-form-item>
				<el-form-item label="姓名" prop="name">
					<el-input v-model="ruleForm.name"></el-input>
				</el-form-item>
				<el-form-item label="所在城市" prop="addrid">
					<el-cascader v-model="ruleForm.addrid" placeholder="试试搜索：上海市" :options="region"
						filterable expand-trigger="hover" clearable>
					</el-cascader>
				</el-form-item>
				<el-form-item label="单位" prop="unit">
					<el-autocomplete style="width:100%" class="inline-input" v-model="ruleForm.unit" :fetch-suggestions="querySearch" placeholder="试试搜索：清华" :trigger-on-focus="false"  @select="handleSelect" >
						<template slot-scope="{ item }">
							<div class="name">{{ item.name }}</div>
						</template>
					</el-autocomplete>
				</el-form-item>
				<el-form-item label="感兴趣的实验" prop="experiment">
					<el-checkbox-group v-model="ruleForm.experiment">
					      <el-checkbox v-for="item in interestList" :key="item.id" :label="item.id+''" name="type">{{item.title}}</el-checkbox>
					</el-checkbox-group>
				</el-form-item>
			</el-form>
				<div class="magauto laing_btn next" @click="setUser">确定</div>
		</div>
	</div>
</template>

<script>
import {chkEmail} from '@/utlis/formrules.js'
import city from '@/utlis/city.js'
import {mapState,mapMutations,mapActions} from 'vuex'
	export default {
		data() {
			return {
				isTosub:false,
				isErwm:false,
				ewm:'',
				timeId:-1,
				key:'',
				err:'',
				region:[],// 地址三级
				ruleForm: {
					avatar:'',
					name:'',//姓名
					addrid:[],//总地区
					nickname: '',//昵称
					email: '',//邮箱
					phone:'',//手机
					unit:'',//单位
					experiment:[],//感兴趣的实验 
				},
				interestList:[],//感兴趣实验列
				rules: {
					nickname:{ required: true, message: '请输入昵称', trigger: 'blur' },
					email:[{ required: true, message: '请输入邮箱', trigger: 'blur' }],
					phone:{ required: true, message: '请输入手机', trigger: 'blur' },
					addrid:[{type: 'array', required: true, message: '请选择地区', trigger: 'change' }],
					name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
					unit:{ required: true, message: '请输入单位', trigger: 'blur' },
					experiment: [ { type: 'array', required: true, message: '请至少选择一个感兴趣的实验', trigger: 'change' } ],
				}
			}
		},
		computed:{
			...mapState(['user','token'])
		},
		created(){
			// this.Postaddresstree();
			this.region = this.asd(city.data||[]);
			this.PostuserExperiment();
		},
		beforeMount(){
			this.getUserMsg();
		},
		beforeDestroy(){
			clearTimeout(this.timeId);
		},
		methods: {
			...mapMutations(['settoken']),
			...mapActions(['getUser']),
			closeErwm(done ){
				clearTimeout(this.timeId);
				done();
			},
			async erwm(key){//获取二维码
				try{
					this.isTosub = true;
					let {code:code1,data:res} = await this.api.GetUserBind_wx();
					if(code1==200){
						let {code,data} = await this.api.Postewm({ key:res.key ,token:this.token});
						if(code==200){
							this.isErwm = true;
							this.ewm = data.url;
							this.settime(data.key);
						}
					}
				}finally{
					this.isTosub = false;
				}	
			},
			async settime(key) {//轮训
				this.timeId = setInterval(async()=>{
					let {code,data,message} = await this.api.Postgonzhohao({ key });
					if(code == 400){
						
					}else if(code==200){
						this.$message({ message: "微信绑定成功", type: "success" });
						clearTimeout(this.timeId);
						this.settoken(data.token);
						this.getUser();
						this.isErwm = false;
					}else{
						clearTimeout(this.timeId);
						this.err = message;
					}
				},2000);
			},
			getUserMsg(){//获取用户信息
				let user = this.user;
				let addrid = [];
				if(user.province)
					addrid.push(user.province)
					if(user.city)
					addrid.push(user.city)
					if(user.area)
					addrid.push(user.area)
				this.ruleForm = {
					avatar:user.avatar||'',
					name:user.name||'',
					addrid,
					nickname:user.nickname||'',
					email:user.email||'',
					phone:user.phone||'',
					experiment:user.experiment||[],
					unit:user.unit||''
				};
			},
			setUser(){//修改用户信息
				this.$refs.ruleForm.validate(async value=>{
					if(!value)return;
					this.isTosub = true;
					let ruleForm = {...this.ruleForm};
					ruleForm.experiment = ruleForm.experiment.join(',');
					ruleForm.province = ruleForm.addrid[0];
					ruleForm.city = ruleForm.addrid[1];
					ruleForm.area = ruleForm.addrid[2];
					let {code} = await this.api.Postuserupdate(ruleForm);
					this.isTosub = false;
					if(code==200)
						this.$message({ message: '资料修改成功', type: 'success' });
					this.getUser();
				})
			},
			async PostuserExperiment(){//获取感兴趣实验
				let {data} = await this.api.PostuserExperiment();
				this.interestList =data;
			},
			async querySearch(queryString, cb) {//单位搜索
				let {data} = await this.api.Postuserunit({title:queryString})
				cb(data);
			},
			handleSelect(e){//添加选择单位
				this.ruleForm.unit = e.name;
			},
			async Postaddresstree(){//获取省市区
				let {data} = await this.api.Postaddresstree();
				this.region = this.asd(data);
			},
			asd(list){//遍历
				return list.map((v,i)=>{
					v.label = v.name;
					// delete v.name;
					v.value = v.id;
					if(v.datas){
						v.children = this.asd(v.datas);
						delete v.datas;
					}
					return v;
				})
			}
		}
	}
</script>

<style lang="scss" scoped="scoped">
.erwema{
	p{
	  text-align: center;
	  color: #868788;
  }
}
	.el-cascader{
		width: 100%;
	}
	/deep/ .el-checkbox__input.is-checked+.el-checkbox__label{
		color: #606266;
	}
	.personal_box {
		width: 500px;
		.next{
			width: 280px;
			height: 40px;
			line-height: 40px;
		}
		.per_zi {
			color: #606266;
			margin-bottom: 22px;

			.per_left {
				box-sizing: border-box;
				padding-right: 12px;
				text-align: right;
				float: left;
				width: 180px;
			}

			.per_right {
				float: left;
			}

			img {
				cursor: pointer;
				width: 100px;
				height: 100px;
			}

			.laing_btn {
				width: 100px;
				height: 30px;
				line-height: 30px;
			}
		}
	}
</style>
